import TestimonialImg from "../../images/testimonials/testimonial-new.png";
import TitleBg from "../../images/pricing/titlebg.svg";
import TestimonialBoxes from "./TestimonialBoxes";
import { Link } from "react-router-dom";

function Testimonials() {
  return (
    <>
      {/* testimonials div */}
      <section className="my-[10rem] mx-auto">
        <div className="container page-padding">
          {/* title */}
          <div className="text-center relative items-center w-full flex flex-col">
            <p className="text-white relative z-10 text-[16px] uppercase font-bold -mb-[10.5rem]">
              Testimonials
            </p>
            <img
              alt="title_img"
              src={TitleBg}
              className="w-[21rem] absolute -top-[6px] "
            />
          </div>

          {/* testimonials wrapper */}
          <div className="border-[#efefef] mt-[17rem] md1000:mt-[9rem] bg-white border-solid border-[9px] p-[30px] min540:h-[48rem] min375:h-[60rem]">
            <div className="bg-black overflow-x-clip w-full h-[33rem] relative">
              {/* img */}
              <img
                alt="girl_img"
                src={TestimonialImg}
                style={{ clipPath: "inset(0 0 20% 0)" }}
                className="absolute bottom-[-2rem] -left-10 z-20 h-[50rem] rounded-tr-[200px] md1000:hidden object-cover"
              />

              {/* all text-boxes */}
              <div className="flex">
                {/* text box */}
                <TestimonialBoxes />
              </div>

              {/* buttons */}
              <div className="flex gap-3 absolute bottom-[25px] right-[35px] z-20 min540:-bottom-[52px] min540:right-[17px]">
                <button
                  title="left"
                  style={{ transition: "all 0.2s" }}
                  className="py-5 px-7 bg-white text-black text-2xl hover:bg-[#FF0336] hover:text-white"
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
                <button
                  title="right"
                  style={{ transition: "all 0.2s" }}
                  className="py-5 px-7 bg-white text-black text-2xl hover:bg-[#FF0336] hover:text-white"
                >
                  <i className="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* collaboration message */}
        <div className="flex flex-col gap-5 justify-center items-center mt-32 border-b border-solid border-[#64646438] pb-28">
          <h2 className="text-[3rem] font-bold text-center">Want to collaborate?</h2>
          <p className="text-[1.8rem] text-[#646464] font-medium text-center max-w-[60rem]">
            We are always open for partnerships and collaborations. 
            Join our mission to transform fitness in Jabalpur.
          </p>
          <Link 
            to="/contact" 
            onClick={() => window.scrollTo(0, 0)}
            className="text-white bg-[#FF0336] py-4 px-10 text-[1.6rem] font-bold uppercase rounded-md hover:bg-black transition-all duration-300"
          >
            Enquire Now
          </Link>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
